import {
  ListItem,
  ListItemAvatar,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { UserAvatar } from '$common/avatar'
import { UserStatus } from '$common/user-status'
import { useUser } from '$logic/users'
import { t } from '$i18n'
import { toHumanReadablePhone } from '$func/phone'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const InfoContainer = styled(Stack)`
  width: 100%;
  justify-content: center;
  margin-right: 15px;
`

const StyledListItem = styled(ListItem)`
  box-sizing: border-box;
  padding: 10px 20px 10px 0;
`

interface Props {
  userId: string
  size?: AvatarSize
}

export function ContactInfoItem({ userId, size = AvatarSize.XL }: Props) {
  const { user, err, loading } = useUser(userId)

  if (err) return <div>error</div>
  if (loading || !user) return <Skeleton variant="text" />

  return (
    <StyledListItem>
      <ListItemAvatar>
        <UserAvatar userId={userId} size={size} />
      </ListItemAvatar>

      <InfoContainer>
        <Typography dir="ltr" variant="subtitle1" component="div">
          {user.deletedAt
            ? t('accounts.deletedAccount')
            : toHumanReadablePhone(user.phone)}
        </Typography>
        <UserStatus userId={userId} />
        {/* // TODO: CHECK THIS WHEN ACCOUNT IS DELETED */}
      </InfoContainer>
    </StyledListItem>
  )
}
